/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Label } from '@atlaskit/form';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import Textfield from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

import { createKbMessages } from './messages';

const styles = cssMap({
	formBody: {
		paddingTop: token('space.200'),
		paddingRight: token('space.250'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.250'),
	},
});

export type KbType = 'EXTERNAL' | 'INTERNAL';

export type KbTypeOption = { label: string; value: KbType };

type CreateKBCardFormProps = {
	spaceName: string;
	onSpaceNameChange: (value: string) => void;
	// Keeping these here (commented) for quick re-enable once backend supports it.
	// selectedType: KbTypeOption;
	// onSelectedTypeChange: (option: KbTypeOption) => void;
};

export const CreateKBCardForm = ({
	spaceName,
	onSpaceNameChange,
}: CreateKBCardFormProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box testId="create-kb-card-form" xcss={styles.formBody}>
			<Stack space="space.150">
				{
					// Type selector is intentionally disabled until backend support is available.
					// <Stack space="space.050">
					// 	<Label htmlFor="create-kb-space-type">
					// 		{formatMessage(createKbMessages.typeLabelMessage)}
					// 	</Label>
					// 	<Select<KbTypeOption>
					// 		inputId="create-kb-space-type"
					// 		options={[
					// 			{
					// 				label: formatMessage(createKbMessages.typeExternalMessage),
					// 				value: 'EXTERNAL',
					// 			},
					// 			{
					// 				label: formatMessage(createKbMessages.typeInternalMessage),
					// 				value: 'INTERNAL',
					// 			},
					// 		]}
					// 		value={selectedType}
					// 		onChange={(option) => option && onSelectedTypeChange(option)}
					// 		testId="create-kb-space-type"
					// 	/>
					// </Stack>
				}
				<Stack space="space.050">
					<Label htmlFor="create-kb-space-name">
						{formatMessage(createKbMessages.nameLabelMessage)}
					</Label>
					<Textfield
						id="create-kb-space-name"
						value={spaceName}
						onChange={(event) => onSpaceNameChange((event.target as HTMLInputElement).value)}
						testId="create-kb-space-name"
					/>
				</Stack>
			</Stack>
		</Box>
	);
};
